import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../../store/actions'
import history from '../../../../../route/history'
import OrderRequest from './OrderRequest'
import Input from '../../../../../module/input'
import { commons } from '../../../../../hook/common'
/**
 * 구매확인서 5단계 / 확인기관, 전자서명
 */
const Step05 = (props) => {
  const nodeBaseInfo = {
    senderId: {
      title: '구매확인서 신청ID',
      type: 'text',
      length: 35,
      required: true,
      message: '구매확인서 신청ID를 입력해주세요.',
      className: 'full',
    },
  }
  // const [docid, setDocid] = useState() => 사용 안해서 주석처리함 2022-05-04
  // const [docSeq, setDocSeq] = useState() => 사용 안해서 주석처리함 2022-05-04
  //주문서 팝업
  const [isOrderOpen, setIsOrderOpen] = useState(false)
  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))
  const [payButton, setPayButton] = useState(false)

  const [state, setState] = useState({
    code: 'KTNET',
    organization: '한국무역정보통신',
    ediDate: '',
    hashString: '',
    senderId: '',
  })

  /**
   * 페이지 진입
   */
  useEffect(() => {
    let id = props.search?.split('=')[1]
    let key = props.search?.split('=')[0]

    if (id && key === '?id') {
      let data = JSON.parse(sessionStorage.getItem(id))

      if (data.step2.length <= 0 || data.step3.length <= 0 || data.step4.length <= 0) {
        history.replace('/service/certapply/1?id=' + id)
        return
      }
      // setDocid(id) => 사용 안해서 주석처리함 2022-05-04
      // setDocSeq(data.step1.crtIssueSeq) => 사용 안해서 주석처리함 2022-05-04
    } else {
      if (props.packageId === 0) {
        history.replace('/service/certapply/1')
      }
    }
    commons.preventKeyDown()
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }
  //결제정보
  useEffect(() => {
    props.issuedCrtOrder()
  }, [])

  useEffect(() => {
    if (props.issuedOrderInfo != undefined) {
      setState({ ...state, ...props.issuedOrderInfo })
    }
  }, [props.issuedOrderInfo])

  const openOrderRequest = () => {
    //console.log('sumInfo = ', sumInfo);
    setIsOrderOpen(true)
  }
  
  const openRequest = (packageId, packageCrtfNo, senderId) => {
    // send id 필수조건 체크 start
    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (state?.[key] === 'null' || !state?.[key] || state?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        document.getElementById(key).focus()
      }
    })
    
    if (errCnt > 0) return
    // send id 필수조건 체크 end
      props.doIssue(props.packageId, props.packageCrtfNo, state.senderId)
  }

  useEffect(() => {
    if (props.OrderResult !== undefined) {
      console.log('order result step05', props.OrderResult)
      setIsOrderOpen(false)
      //setPayButton(true)
      props.doIssue(props.packageId, props.packageCrtfNo, state.senderId)
    }
  }, [props.OrderResult])

  const generateRow = (key) => {
    const node = nodeInfo[key]
    let idx = Object.keys(nodeBaseInfo).findIndex((objKey) => objKey === key)
    let className = 'form-keyword '
    let wrapperClassName = node?.wrapperClassName

    return (
      <Input
        id={key}
        name={key}
        type={node.type}
        value={state?.[key] === 'null' ? '' : state?.[key] || ''}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={wrapperClassName}
        className={className + node?.className}
        placeholder={node?.placeholder}
        message={node?.message}
        onChange={handleChange}
        readOnly={node.readOnly}
        required={node.required}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        length={node.length}
        errMessage={node.errMessage}
      />
    )
  }
  
  return (
    <React.Fragment>
      {isOrderOpen && (
        <OrderRequest
          isOrderOpen={isOrderOpen}
          onClose={() => setIsOrderOpen(false)}
          data={props.issuedOrderInfo}
          doIssue={props.doIssue}
          packageId={props.packageId}
          packageCrtfNo={props.packageCrtfNo}
          senderId={state.senderId}
          /* sendOrderInfo={orderInfo} */
        />
      )}

      <div className="guide-box gray mt30">
        <dl className="dlist1">
          <dt>발급신청 유의사항</dt>
          <dd>신청업체는 전자무역촉진에 관한 법률 시행규정 제7조에 의거 첨부근거서류를 5년 동안 보관하여야 합니다.</dd>
          <dd>마이크로 필름, 광디스크, 전자문서보관소 등에 의해서도 보관될 수 있습니다.</dd>
          <dd>위의 사항을 대외무역법 제 18조에 따라 신청합니다.</dd>
          <dd>결제가 완료되면 증명서는 자동 신청됩니다.</dd>
        </dl>
      </div>
      <h3 className="h3-tit mt30">발급기관</h3>
      {/* <p className="required">※총 금액의 통화 코드를 먼저 선택하신 후, 구매 물품을 등록하시면 합계가 자동 계산됩니다.</p> */}
      <table className="tbl-write">
        <caption>코드, 기관명 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              <em className="required" /> 코드
            </th>
            <td>
              <input type="text" className="form-keyword" id="code" name="code" value={state.code} readOnly={true} title={'코드'} />
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 기관명
            </th>
            <td>
              <input
                type="text"
                className="form-keyword"
                id="organization"
                name="organization"
                value={state.organization}
                readOnly={true}
                title={'기관명'}
              />
            </td>
          </tr>
          <tr>
            <th scope="row"><em className="required" />구매확인서 신청ID </th>
            <td>
              {generateRow('senderId')} {/* 구매확인서 신청ID */}
              {/*
              <input
                type="text"
                className="form-keyword"
                id="senderId"
                name="senderId"
                value={state.senderId}
                onChange={handleChange}
                title={'구매확인서 신청ID'}
              />
               */}
              <p className="required">uTradeHub id - ERP senderId </p>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="btn-block">
        <a
          href="#"
          className="btn-secondary md"
          onClick={(e) => {
            e.preventDefault()
            props.doDelete()
          }}
        >
          취소
        </a>
        <span className="right">
          <a
            href="#"
            className="btn-secondary md"
            onClick={(e) => {
              e.preventDefault()
              props.goStepPrev()
            }}
          >
            이전
          </a>
          <a href="#" className="btn-primary md" onClick={() => openRequest(props.packageId, props.packageCrtfNo, state.senderId)}>
            발급신청
          </a>
          {/*
          <a
            href="#"
            className="btn-primary md cursor"
            onClick={(e) => {
              e.preventDefault()
              openOrderRequest()
            }}
          >
            결제
          </a>
          */}
          {/*  {payButton ?(
            <a href="#" className="btn-primary md" onClick={props.doIssue}>
              다음
            </a>  
          ):( */}
          {/*  <a className="btn-primary md cursor"  onClick={openOrderRequest}>
              결제
            </a> */}
          {/*  )} */}
        </span>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.certapply?.data?.step3,
    totalData: state.certapply.data,
    isCalled: state.certapply.isCalled,
    issuedOrderInfo: state.certapply?.issuedOrderInfo,
    OrderResult: state.certapply?.OrderResult,
  }
}

const actionCreators = {
  setCalled: certapplyActions.setCalled,
  alert: certapplyActions.alert,
  error: alertActions.error,
  issuedCrtOrder: certapplyActions.issuedCrtOrder,
}

export default connect(mapStateToProps, actionCreators)(Step05)
